import React from 'react';
import './css/Projects.css';
import Typography from '@mui/material/Typography';


function Projects(props)  {
  return (
    <div>
      <div className="Header">
        <br/>
        <Typography variant="h3">Projects</Typography>
      </div>
      <br/>
    </div>
  );
}

export default Projects;
